<template>
  <div
    id="back-to-top"
    @click="goToTop()"
    :class="[scrolled?'visible':'hidden']"
  >
  <img :src="`${$STATIC_PATH}/img/back_to_top_snapshot_40.png`" alt="Back to top"/>
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
})
export default class BackToTop extends Vue {
  scrolled = false
  created () {
    window.addEventListener('scroll', this.handleScroll)
  }
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  }
  handleScroll () {
    this.scrolled = window.pageYOffset > 0
  }
  goToTop () {
    window.scrollTo(0, 0)
  }
}
</script>

<style lang="scss" scoped>
@import './css/const.scss';

#back-to-top {
  display: none;
}

@media screen and (max-width: $screen-width-2-column-small) {
  #back-to-top.hidden {
    display: none;
  }

  #back-to-top.visible {
    position: fixed;
    display: block;
    right: 20px;
    bottom: 40px;
    z-index: 999999;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/sqs/2025/BackToTop.vue